import React, { useEffect, useState } from 'react'
import { clearFriendList, seeFriendList, deleteFriend, blockFriend, unblockFriend,cancelFriendRequest } from '../../actions/friendsActions'
import { connect } from 'react-redux';
import { searchFriends } from '../../actions/searchActions'
import { Translate } from '../../language';
import inMemoryJWT from '../../auth/inMemoryJwt';
import ModalMenu from '../../containers/ModalMenu';
import ListSocial from '../../containers/Profile/ListSocial/ListSocial';
import { ReactComponent as OptionsIcon } from '../../img/ic_opciones.svg';
import circle from '../../img/circulogris.png';
import searchIcon from '../../img/ic__buscador.png'


const FriendList = ({ clearFriendList, match, history, seeFriendList, userFriendList, searchFriends, deleteFriend, searchList,
    isLoadingSearch, blockFriend, isLoading, relationBetween, unblockFriend }) => {
    const id = match.params.userID
    console.log();
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeFriendList(id)
        })
        return () => {
            clearFriendList()
        }

    }, [id])

    const [searchText, setSearchText] = useState("")
    const deleteSocial = (id)=>{
        deleteFriend(id,true)
    }

    return (
        <ListSocial
            iduser={id}
            listSocial={userFriendList}
            listName='Amigos'
            deleteSocial={deleteSocial}
        />
    )

    return (
        <div className="background-gray">
            <div className="wrapper-24 container-80">
                <div className="friend-list-container">
                    <div className="wrapper-2 mt-5 mb-5 centerItems">
                        <div className="friends-count-friend-list">
                            {Translate('friends', 'es')}
                            <div className="littleText ml-1 mb-1">{!isLoading && Object.values(userFriendList).length}</div>
                        </div>
                        <div className="search-friend-list">
                            <div className="search-bar-friends ">
                                <img src={searchIcon} alt="img" className="img-search-bar" />
                                <input className="input-inside-div" onChange={(e) => {
                                    setSearchText(e.target.value)
                                    searchFriends(e.target.value)
                                }} type="text" placeholder="Buscar..." />
                            </div>
                        </div>
                    </div>
                    {searchText === "" ?
                        <div className="">
                            {!isLoading && Object.values(userFriendList).length > 0 ? userFriendList.map(([id, { user, social }]) => {
                                { console.log() }
                                var contentModal = <div className='modal-options'>
                                    <div className="modal-options-social-list">
                                        <div className="row">
                                            {/* { social.isBlockerSecond ?
                                            <div onClick={() => { unblockFriend(user._id, social) }} className="pointer">
                                            'Desbloquear'
                                            </div>
                                            :
                                            <div onClick={() => { blockFriend(user._id,social) }} className="">{Translate('blockFriend', 'es')}</div>
                                            } */}
                                            <div onClick={() => { deleteFriend(user._id) }} className="">{Translate('deleteFriend', 'es')}</div>
                                        </div>
                                    </div>
                                </div>
                                return <div key={user._id} className="content-social-show-list">
                                    {user.picture ? <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" onError={e => e.target.src = circle} src={user.picture.url ? user.picture.url.small : user.picture}></img> :
                                        <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" src={circle}></img>
                                    }
                                    <div className="content-name-show-list-social">
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer text-bold">@{user.name}</div>
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer ">{user.name}</div>
                                    </div>
                                    <div className="content-options-show-list-social">
                                        <ModalMenu
                                            contentButton={<OptionsIcon className="black-svg" height="15" width="35" />}
                                            contentModal={contentModal}
                                        />
                                    </div>
                                </div>
                            }) :
                                'Aún no agregas ningún amigo'
                            }
                        </div>
                        :
                        <div className="">
                            {!isLoadingSearch && Object.values(searchList).length > 0 ? Object.values(searchList).map((user, index) => {
                                var contentModal = <div className='modal-options'>
                                    <div className="modal-options-social-list">
                                        <div className="row">
                                            <div onClick={() => { deleteFriend(user._id) }} className="">{Translate('deleteFriend', 'es')}</div>
                                            <div onClick={() => { blockFriend(user._id) }} className="">{Translate('blockFriend', 'es')}</div>
                                        </div>
                                    </div>
                                </div>
                                return <div key={user._id} className="content-social-show-list">
                                    {user.picture ? <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" onError={e => e.target.src = circle} src={user.picture.url ? user.picture.url.small : user.picture}></img> :
                                        <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" src={circle}></img>
                                    }
                                    <div className="content-name-show-list-social">
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer text-bold">@{user.name}</div>
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer ">{user.name}</div>
                                    </div>
                                    <div className="content-options-show-list-social">
                                        <ModalMenu
                                            contentButton={<OptionsIcon className="black-svg" height="15" width="35" />}
                                            contentModal={contentModal}
                                        />
                                    </div>
                                </div>
                            }) :
                                'No existen resultados para la busqueda'
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        userFriendList: state.userInfo.friendList,
        isLoading: state.userInfo.isLoadingFriendList,
        searchList: state.users.friendSearchList,
        isLoadingSearch: state.users.isLoadingSearchFriendList,
        relationBetween: state.userInfo.relationBetween,
    }
}

export default connect(mapStateToProps, { clearFriendList, seeFriendList, deleteFriend, blockFriend, searchFriends, unblockFriend,deleteFriend })(FriendList)
